import request from '@/utils/request'

export default {
  // 計算頁面匯出資料
  /**
   *
   * @param data
   * type Required. Type: String.
   * qp_simulation_report Required. Type: array.
   * @returns Promise
   */
  exportSimulationReport (data) {
    return request({
      method: 'post',
      url: '/api/v1/qp/reports/simulation_report',
      data,
      responseType: 'arraybuffer'
    })
  },
  // 比較頁面匯出資料
  exportCompareReport (data) {
    return request({
      method: 'post',
      url: '/api/v1/qp/reports/comparision_report',
      data,
      responseType: 'arraybuffer'
    })
  }
}
